import React, { useState } from "react";
import { api } from "../api";

type Props = {
  /** Wird der Username serverseitig erzwungen? Steuert nur, ob das Feld
   *  prominent ist — schaden tut es nie, ihn mitzuschicken. */
  onSuccess: () => void;
  brandName?: string | null;
};

export const Login: React.FC<Props> = ({ onSuccess, brandName }) => {
  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError(null);
    try {
      await api.authLogin(password, username.trim() || undefined);
      onSuccess();
    } catch {
      setError("Login fehlgeschlagen — bitte Zugangsdaten prüfen.");
      setPassword("");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-screen">
      <form className="login-card" onSubmit={(e) => void submit(e)}>
        <div className="login-title">
          Marketing <strong>Studio</strong>
        </div>
        <p className="login-sub">{brandName ? `${brandName} · Anmeldung` : "Anmeldung erforderlich"}</p>

        <label className="login-label">
          Benutzer
          <input
            type="text"
            autoComplete="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            disabled={busy}
          />
        </label>

        <label className="login-label">
          Passwort
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={busy}
            autoFocus
          />
        </label>

        {error ? <div className="login-error">{error}</div> : null}

        <button className="login-btn" type="submit" disabled={busy || password.length === 0}>
          {busy ? "Anmelden…" : "Anmelden"}
        </button>
      </form>
    </div>
  );
};
